import {Message} from 'primereact/message';

import React, {useEffect, useRef, useState} from 'react';
import {Dialog} from 'primereact/dialog';
import {FileUpload} from "primereact/fileupload";
import {Button} from "primereact/button";
import {RadioButton} from "primereact/radiobutton";

import {InputTextarea} from 'primereact/inputtextarea';
import {InputText} from "primereact/inputtext";
import {executePythonScript, getPythonExecutions} from "../../api/python/python-execution-service";
import {showError} from "../../api/notification/ToastManager";
import {removeNonUtf8} from "../../api/utils/Strings";


function ExecutePythonScript({
                                 showNewPythonExecDialog,
                                 setShowNewPythonExecDialog,
                                 setPythonExecutions,
                                 setSelectedPythonExecutionIndex
                             }) {

    const [selectedScriptFile, setSelectedScriptFile] = useState(null)
    const fileUploadRef = useRef(null);
    const [scriptType, setScriptType] = useState("file")
    const [scriptText, setScriptText] = useState("")
    const scriptTextRef = useRef(null);
    const [executionName, setExecutionName] = useState("")
    const [executeButtonDisable, setExecuteButtonDisable] = useState(true)
    const [isLoading, setIsLoading] = useState(false)

    function isStringValid(string) {
        return string !== undefined && string !== null && string !== "";
    }

    useEffect(() => {
        const validInput = isStringValid(executionName) &&
            ((isStringValid(selectedScriptFile) && scriptType === "File") ||
                (isStringValid(scriptText) && scriptType === "Text"))
        setExecuteButtonDisable(!validInput)
    }, [
        executionName,
        selectedScriptFile,
        scriptType,
        scriptText
    ]);

    async function startExecutingPythonScript() {
        setIsLoading(true)
        const data = new FormData();
        if (scriptType === "File")
            data.append('file', selectedScriptFile);
        let params = {
            id: 0,
            name: executionName,
            consoleOutput: "",
            scriptContent: scriptType === "Text" ? scriptText : null,
        }

        data.append('params', JSON.stringify(params));
        const exec = await executePythonScript(data)
        const executions = await getPythonExecutions()
        setPythonExecutions(executions)
        const index = executions.findIndex(e => e.id === exec.id);
        setSelectedPythonExecutionIndex(index);
        setShowNewPythonExecDialog(false)
        setIsLoading(false)
        resetFields();

    }

    const footerContent = (
        <div>
            <Button
                disabled={executeButtonDisable || isLoading}
                label="Execute" icon="pi pi-forward"
                onClick={startExecutingPythonScript}
                style={{backgroundColor: "#487c84"}}
                autoFocus/>
        </div>
    );


    const onSelect = (e) => {
        const file = e.files[0]
        if (!file.name.endsWith(".py")) {
            showError("Please select a Python (.py) file.");
            fileUploadRef.current.clear();
            return
        }
        setSelectedScriptFile(e.files[0])
        fileUploadRef.current.clear();
    };

    useEffect(() => {
        if (scriptType === "Text" && scriptTextRef !== null) {
            setTimeout(() => {
                scriptTextRef.current?.focus();
            }, 100);
        }
    }, [scriptTextRef, scriptType]);

    function resetFields() {
        setSelectedScriptFile(null)
        setScriptType("")
        setExecutionName("")
        setScriptText("")
    }

    return (
        <div>
            <Dialog
                maximizable
                maximized={true}
                position={"top"}
                footer={footerContent}
                header="Execute python script" visible={showNewPythonExecDialog} style={{width: '50vw'}}
                onHide={() => {
                    if (!showNewPythonExecDialog || isLoading) return;
                    setShowNewPythonExecDialog(false);
                    resetFields();
                }}>
                <div className={"grid"}>
                    <div className={'mt-4 sm:col-12 xl:col-6 md:col-12 '}>

                        <label>Execution name</label>
                        <InputText
                            disabled={isLoading}
                            onChange={(e) => {
                                if (e.nativeEvent?.data === null
                                    || e.nativeEvent?.data?.match(/^[-_a-zA-Z0-9 ]+$/) !== null) {
                                    const value = removeNonUtf8(e.target.value);
                                    setExecutionName(value)
                                }
                            }}
                            value={executionName}
                            type="text" placeholder="Insert an execution name" style={{width: "100%"}}/>

                    </div>
                </div>

                <div className={"mt-3"}>
                    <label>Python Script</label>
                    <div className={"flex flex-wrap gap-3 mt-2 mb-2"}>
                        <div className="flex align-items-center">
                            <RadioButton
                                disabled={isLoading}
                                inputId="file" name="scriptType" value="File"
                                onChange={(_) => {
                                    setScriptType("File")
                                }}
                                checked={scriptType === "File"}
                            />
                            <label htmlFor="file" className="ml-2">Upload a file</label>
                        </div>
                        <div className="flex align-items-center">
                            <RadioButton
                                disabled={isLoading}
                                inputId="text" name="scriptType" value="Text"
                                onChange={(_) => {
                                    setScriptType("Text")
                                }}
                                checked={scriptType === "Text"}
                            />
                            <label htmlFor="text" className="ml-2">Insert a text</label>
                        </div>
                    </div>
                    {scriptType === "File" &&
                        <div>
                            <FileUpload
                                disabled={isLoading}
                                ref={fileUploadRef}
                                mode="basic"
                                accept={".py"}

                                maxFileSize={1000000}
                                onSelect={onSelect}/>
                            {selectedScriptFile !== null &&
                                <div style={{display: "flex", alignItems: "center", justifyContent: "flex-start"}}>
                                    <p className={"m-0 p-0"}>
                                        {selectedScriptFile?.name}
                                    </p>
                                    <Button
                                        onClick={() => {
                                            setSelectedScriptFile(null)
                                        }}
                                        size={"small"} text severity={"danger"} icon={"pi pi-trash"}/>
                                </div>}
                        </div>
                    }
                    {scriptType === "Text" &&
                        <div>
                            <InputTextarea
                                disabled={isLoading}
                                ref={scriptTextRef}
                                onChange={(e) => {
                                    setScriptText(e.target.value)
                                }}
                                value={scriptText}
                                style={{minWidth: "100%", maxWidth: "100%"}}
                                rows={17}
                            />

                        </div>
                    }
                </div>
                <Message severity={"warn"} className={"mt-2"} text="main() is required as the main function"/>
            </Dialog>
        </div>
    );
}

export default ExecutePythonScript;